import Vue from "vue"
import VueRouter from "vue-router"
import { setupMockedAuthGuard } from "./guards.js"
import dashboard from "@/modules/dashboard/router/index.js"
import products from "@/modules/products/router/index.js"
import apps from "@/modules/apps/router/index.js"
import uiEditor from "@/modules/uiEditor/router/index.js"
import auth from "@/modules/auth/router/index.js"
import releases from "@/modules/releases/router/index.js"
import templates from "@/modules/templates/router/index.js"
import files from "@/modules/files/router/index.js"
import languages from "@/modules/languages/router/index.js"

Vue.use(VueRouter)

const routes = [
	{
		path: "/",
		redirect: "/dashboard"
	},
	...dashboard,
	...products,
	...apps,
	...uiEditor,
	...auth,
	...releases,
	...templates,
	...files,
	...languages,
	{
		path: "*",
		redirect: "/"
	}
]

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
	scrollBehavior() {
		return { x: 0, y: 0 }
	}
})

//MOCK: mocked auth guard
// Should be replaced with solid permission check strategy per every route
setupMockedAuthGuard(router)

export default router
